/**
 * Agrupa filas planas del tablero operativo por empresa (una tarjeta / empresa).
 */

export function pendingItemTitle(row) {
  return (
    row?.title
    || row?.obligation_name
    || row?.task_name
    || row?.message
    || "Pendiente"
  );
}

export function pendingItemMeta(row, reportId) {
  const parts = [];
  const period = row?.period || row?.period_key;
  if (period) parts.push(String(period));
  const due = row?.fecha_fiscal || row?.due_date || row?.scheduled_for;
  if (due) parts.push(String(due).slice(0, 10));
  if (reportId === "overdue" && row?.days_overdue != null) {
    parts.push(`${row.days_overdue} día(s) vencido(s)`);
  } else if (reportId === "upcoming_due_dates" && row?.days_remaining != null) {
    parts.push(`${row.days_remaining} día(s) restante(s)`);
  }
  return parts.filter(Boolean).join(" · ");
}

/**
 * @param {Array<Record<string, unknown>>} items
 * @returns {Array<{ key: string, fiscal_client_id: string|null, client_name: string, client_rfc: string, items: Array }>}
 */
export function groupOperationalItemsByClient(items) {
  const map = new Map();
  for (const item of items || []) {
    const fiscalId = item?.fiscal_client_id ? String(item.fiscal_client_id) : "";
    const rfc = item?.client_rfc ? String(item.client_rfc).trim().toUpperCase() : "";
    const name = item?.client_name ? String(item.client_name).trim() : "";
    const key = fiscalId || rfc || name || "__sin_empresa__";
    if (!map.has(key)) {
      map.set(key, {
        key,
        fiscal_client_id: fiscalId || null,
        client_name: name || (rfc ? rfc : "Sin empresa"),
        client_rfc: rfc,
        items: [],
      });
    }
    const bucket = map.get(key);
    if (!bucket.client_name || bucket.client_name === "Sin empresa") {
      if (name) bucket.client_name = name;
    }
    if (!bucket.client_rfc && rfc) bucket.client_rfc = rfc;
    if (!bucket.fiscal_client_id && fiscalId) bucket.fiscal_client_id = fiscalId;
    bucket.items.push(item);
  }
  return Array.from(map.values()).sort((a, b) =>
    String(a.client_name).localeCompare(String(b.client_name), "es", { sensitivity: "base" }),
  );
}

/** Reportes que se muestran agrupados por empresa (vista auxiliar). */
export const CLIENT_GROUPED_REPORT_IDS = new Set([
  "overdue",
  "upcoming_due_dates",
  "pending_tasks",
]);
